import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { selectors } from '@formue-app/core';

import { ReactComponent as FormueLogoFull } from '../../assets/icons/logo/formue-logo-full.svg';
import { ReactComponent as FormueLogoFullColors } from '../../assets/icons/logo/formue-logo-full-colors.svg';
import { ReactComponent as FormueLogoIcon } from '../../assets/icons/logo/formue-logo-icon.svg';
import { ReactComponent as FormueLogoIconColor } from '../../assets/icons/logo/formue-logo-icon-color.svg';

import { ReactComponent as ChristmasHatIcon } from '../../assets/icons/seasonal/christmas/christmas-hat.svg';

const HatWrapper = styled.div`
  position: absolute;
  margin-top: ${(props) => -0.35 * props.size}px;
  margin-left: ${(props) => -0.3 * props.size}px;
  display: flex;
`;

const LogoWrapper = styled.div`
  position: relative;
`;

const {
  entities: {
    configuration: { seasonalDecorationIsActiveSelector },
  },
} = selectors;

const LogoFull = (props) => {
  const { monochrome, ...rest } = props;
  return monochrome ? (
    <FormueLogoFull {...rest} />
  ) : (
    <FormueLogoFullColors {...rest} />
  );
};

const LogoIcon = (props) => {
  const { monochrome, ...rest } = props;
  return monochrome ? (
    <FormueLogoIcon {...rest} />
  ) : (
    <FormueLogoIconColor {...rest} />
  );
};

export const Logo = (props) => {
  const { size = 26, logoIcon, showSeasonalDecoration = true, ...rest } = props;
  const christmasActive = useSelector(
    seasonalDecorationIsActiveSelector('christmas')
  );

  const showChristmasDecoration = showSeasonalDecoration && christmasActive;

  // Relative size of the christmas hat to the logo size.
  // Adjusted so that it works for any size of the logo
  const christmasHatRelativeSize = parseInt(size) * 0.8;

  return (
    <LogoWrapper {...rest}>
      {showChristmasDecoration ? (
        <HatWrapper {...rest} size={size}>
          <ChristmasHatIcon
            width={christmasHatRelativeSize * 1.4}
            height={christmasHatRelativeSize}
          />
        </HatWrapper>
      ) : null}
      {logoIcon ? (
        // For the logo icon we have to scale the size (which is handled as width in the full icon)
        // to get the coresponding height
        <LogoIcon {...rest} height={size} />
      ) : (
        <LogoFull {...rest} height={size} />
      )}
    </LogoWrapper>
  );
};
